import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    deepStringFind,
    errorRedirect,
    inject,
    Loader,
    NothingHere,
    SubTopBar,
    Title,
    toArray,
} from 'Mri.Web.Common';
import * as React from 'react';
import { BsCardList } from '@react-icons/all-files/bs/BsCardList';
import { LinkContainer } from 'react-router-bootstrap';
import { Input } from 'reactstrap';
import { CloudConfigItem } from './CloudConfigItem';
import { CloudConfigsStore } from './CloudConfigsStore';

@autoinject
@observer
export class CloudConfigList extends React.Component {
    @action
    public async componentDidMount() {
        this.loading = true;
        try {
            await this.cloudConfigsStore.loadAllAsync();

            const promises = toArray(this.cloudConfigsStore.configs).map(m =>
                this.cloudConfigsStore.loadStatusAsync(m.cloudConfigGuid)
            );
            await Promise.all(promises);
        } catch (e: any) {
            errorRedirect(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div className="container-fluid">
                <Title>Configs</Title>

                <SubTopBar>
                    <LinkContainer to="/cloud-configs/configs/create">
                        <a className="btn btn-primary">Create Config</a>
                    </LinkContainer>

                    <div className="mx-2 border" />

                    <Input
                        type="text"
                        value={this.searchValue}
                        onChange={this.onSearchInputChange}
                        className="mw-450"
                        placeholder="Search Configs..."
                    />
                </SubTopBar>

                <div className="row">
                    <div className="col-12 px-0">
                        <table className="table table-striped w-100 h-100">
                            <thead>
                                <tr>
                                    <th>Name</th>

                                    <th>Status</th>

                                    <th>Schedule</th>

                                    <th>Config</th>

                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.configs.map(m => (
                                    <CloudConfigItem config={m} key={m.cloudConfigGuid} />
                                ))}
                            </tbody>
                        </table>

                        <NothingHere empty={this.configs.length <= 0} icon={<BsCardList />} loading={this.loading} />
                    </div>
                </div>
            </div>
        );
    }

    @bind
    @action
    private async onSearchInputChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        this.searchValue = target.value;
    }

    @computed
    private get configs() {
        let configs = toArray(this.cloudConfigsStore.configs);

        if (this.searchValue) {
            configs = configs!.filter(c => {
                const s = {
                    config: c,
                };

                return deepStringFind(s, this.searchValue);
            });
        }

        return configs;
    }

    @inject
    private readonly cloudConfigsStore!: CloudConfigsStore;
    @observable private searchValue: string = '';
    @observable private loading = false;
}
